/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesViewerAliases {
  CONTEXTUAL_BAR_CLINICAL_NOTES_MENU = 'contextual-bar-clinical-notes-menu',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_MEDICAL_OPINION = 'field-medical-opinion',
  FIELD_NOTE = 'field-note',
  FIELD_NR_ATENDIMENTO = 'field-nr_atendimento',
  FIELD_SPECIALTY_OPINION = 'field-specialty-opinion',
  FORM_CLINICAL_NOTE_VIEWER = 'form-clinical-note-viewer',
  HTML_VIEWER_0 = 'html-viewer-0',
  INACTIVATE_CLINICAL_NOTE_ACTION = 'inactivate-clinical-note-action',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  LAYOUT_CLINICAL_NOTES_VIEWER = 'layout-clinical-notes-viewer',
  NEW_CLINICAL_NOTE_ACTION = 'new-clinical-note-action',
  DELETE_CLINICAL_NOTE_ACTION = 'delete-clinical-note-action',
  PANEL_HEADER = 'panel-header',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_NR_ATENDIMENTO = 'text-nr-atendimento',
}
export { ClinicalNotesViewerAliases };
